import { Advantage } from './advantages.types';
import { ImagePathWithRenditions } from './ImageTypes';
import { BasketPopupRecommendations } from './product-detail/ProductTypes';

export type GiftVoucherContainerProps = {
  images?: Array<{
    uri: string;
  }>;
  logo?: {
    uri: string;
  };
  subtitle?: string;
  title?: string;
  amountConfig: GiftVoucherAmountConfig;
  basketPopUp?: BasketPopupRecommendations;
  hideImageOverlay?: boolean;
  advantages?: Array<Advantage>;
  lazyLoadedImages?: Array<ImagePathWithRenditions>;
  lazyLoadedLogo?: ImagePathWithRenditions;
};

export type GiftVoucherAmountConfig = {
  minAmount: number;
  maxAmount: number;
};
